import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

const PrivacyPolicy = () => (
  <PolicyLayout
    title="Privacy Policy"
    kicker="Your Trust, Protected"
    intro="GirlyGrove respects your privacy and is committed to protecting your personal information."
    sections={[
      {
        heading: "Information We Collect",
        bullets: [
          "Name",
          "Email Address",
          "Phone Number",
          "Shipping Address",
          "Payment Information (processed securely through payment gateways)",
        ],
      },
      {
        heading: "How We Use Your Information",
        bullets: [
          "To process and deliver orders",
          "To provide customer support",
          "To improve our website and services",
          "To send order updates and promotional communications",
        ],
      },
      {
        heading: "Data Security",
        paragraphs: ["We implement appropriate security measures to protect your personal information."],
      },
      {
        heading: "Third-Party Services",
        paragraphs: [
          "We may share necessary information with logistics partners, payment gateways, and service providers solely for order fulfillment and business operations.",
        ],
      },
      {
        heading: "Your Rights",
        paragraphs: ["You may request access, correction, or deletion of your personal information by contacting us."],
      },
    ]}
  />
);

export default PrivacyPolicy;
